import React from 'react'
import BasicEditor from 'shared/editor/Basic'

require('tinymce/plugins/autoresize/plugin')
require('shared/editor/plugins/groove-paste-cleanup')

const fixupPlainTextDraft = plain => {
  if (!plain) return ''
  return plain.replace(/\n/g, '<br />')
}

class FacebookEditor extends React.Component {
  onChange = (content, options) => {
    if (this.editorRef) {
      const plain = this.getPlainText()
      this.props.onChange(plain, options)
    }
  }

  getPlainText = () => {
    return this.editorRef.getBody().innerText
  }

  saveRef = node => {
    const { forwardRef } = this.props
    this.editorRef = node
    if (forwardRef) forwardRef(node)
  }

  render() {
    const { config, content, ...rest } = this.props
    const plugins = 'paste autoresize'

    return (
      <BasicEditor
        config={{
          autoresize_bottom_margin: 20,
          autoresize_min_height: 100,
          autoresize_on_init: true,
          body_class: 'editor-facebook',
          plugins,
          resize: false,
          toolbar: false,
          elementpath: false,
          valid_elements: 'p,br,strong/b',
          forced_root_block: false,
          ...config,
        }}
        forwardRef={this.saveRef}
        initialValue={fixupPlainTextDraft(content)}
        onChange={this.onChange}
        placeholder={'Type your reply here...'}
        {...rest}
      />
    )
  }
}

export default FacebookEditor
